/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';

const CallToActionButton = ({ status, callToActions }) => {
  const config = callToActions[status];
  const { icon: Icon, text, onClick, testId } = config;

  return (
    <div
      className="sui-flex sui-items-center sui-gap-1 sui-cursor-pointer"
      data-testid="quote-icon-text-action"
      onClick={onClick}
    >
      <Icon
        data-testid={testId}
        size="small"
      />
      <div className="sui-gap-2 sui-hidden xl:@xl:sui-flex">
        <Typography decoration="underline">{text}</Typography>
      </div>
    </div>
  );
};

CallToActionButton.propTypes = {
  status: PropTypes.oneOf(['active', 'expired']).isRequired,
  callToActions: PropTypes.objectOf(
    PropTypes.shape({
      icon: PropTypes.elementType.isRequired,
      text: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      testId: PropTypes.string.isRequired
    })
  ).isRequired
};

export default CallToActionButton;
